import React, {Ref} from "react";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {getOfferCardAddressContext} from "../../../utils/get_offer_card_address";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {IOfferListListStore} from "../../reducers/desktop_offer_list_list_reducer";
import {OfferListSubType} from "../../types/OfferListSubType";
import {EmptyListWithNewsLetter} from "../EmptyListWithNewsLetter";
import {OfferListingUspAnalyticsProvider} from "../OfferListingUspAnalyticsProvider";
import {DefaultOfferListing} from "./listing_variants/DefaultOfferListing";
import {SoonFinishedOffersListing} from "./listing_variants/SoonFinishedOffersListing";

interface IProps {
    ref?: Ref<HTMLDivElement | null>;
    list: IOfferListListStore;
    metaDataTitle: string;
    selectedRegion: ISelectedRegion[];
    className?: string;
    offerListSubType?: OfferListSubType;
    isSidebarReserved?: boolean;
    isInitialOfferListFetchDone: boolean;
}

export const OfferList = React.memo((props: IProps) => {
    const {ref, isInitialOfferListFetchDone, list, metaDataTitle, selectedRegion, className, isSidebarReserved, offerListSubType} = props;
    const {count, offers, unavailable_offers, unavailable_offers_count, soon_finished_offers, requestState, latestQuery} = list;
    const offersCount = count;
    const isFilteredByFinishedConstruction = latestQuery.construction_end_date === "0";
    const hasNoSelectedOffersToShow = offers.length === 0;
    const hasOffersThatWillBeSoonFinishedToShow = soon_finished_offers.length > 0;
    const showSoonFinishedListing = isFilteredByFinishedConstruction && hasNoSelectedOffersToShow && hasOffersThatWillBeSoonFinishedToShow;
    const addressContext = React.useMemo(
        () =>
            getOfferCardAddressContext({
                searchedRegionQuery: latestQuery.region,
                searchDistance: latestQuery.distance,
                selectedRegions: selectedRegion
            }),
        [latestQuery.distance, latestQuery.region, selectedRegion]
    );

    const renderOfferListVariant = () => {
        const hasRequestSucceed = requestState === RequestState.Success;

        // When there are active or unavailable offers to show (or list is still loading)
        if (offersCount || (!showSoonFinishedListing && unavailable_offers_count > 0)) {
            return (
                <OfferListingUspAnalyticsProvider addressContext={addressContext}>
                    <DefaultOfferListing
                        list={list}
                        metaDataTitle={metaDataTitle}
                        selectedRegion={selectedRegion}
                        offerListSubType={offerListSubType}
                        isSidebarReserved={isSidebarReserved}
                        isInitialOfferListFetchDone={isInitialOfferListFetchDone}
                        addressContext={addressContext}
                    />
                </OfferListingUspAnalyticsProvider>
            );
        }

        // When user requested offers that have been constructed, yet we have nothing to show. Show offers that soon will be finished
        if (showSoonFinishedListing && hasRequestSucceed) {
            return (
                <OfferListingUspAnalyticsProvider addressContext={addressContext}>
                    <SoonFinishedOffersListing
                        offers={soon_finished_offers}
                        unavailableOffers={unavailable_offers}
                        dividerVisible
                        addressContext={addressContext}
                    />
                </OfferListingUspAnalyticsProvider>
            );
        }

        // When there is nothing we can show, render after fetch finished
        if (hasRequestSucceed) {
            return (
                <WideContent>
                    <EmptyListWithNewsLetter className={css({mt: 5})} useHeader />
                </WideContent>
            );
        }
    };

    return (
        <div className={className} ref={ref}>
            {renderOfferListVariant()}
        </div>
    );
}, isEqual);
import React, {Ref} from "react";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {getOfferCardAddressContext} from "../../../utils/get_offer_card_address";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {IOfferListListStore} from "../../reducers/desktop_offer_list_list_reducer";
import {OfferListSubType} from "../../types/OfferListSubType";
import {EmptyListWithNewsLetter} from "../EmptyListWithNewsLetter";
import {OfferListingUspAnalyticsProvider} from "../OfferListingUspAnalyticsProvider";
import {DefaultOfferListing} from "./listing_variants/DefaultOfferListing";
import {SoonFinishedOffersListing} from "./listing_variants/SoonFinishedOffersListing";

interface IProps {
    ref?: Ref<HTMLDivElement | null>;
    list: IOfferListListStore;
    metaDataTitle: string;
    selectedRegion: ISelectedRegion[];
    className?: string;
    offerListSubType?: OfferListSubType;
    isSidebarReserved?: boolean;
    isInitialOfferListFetchDone: boolean;
}

export const OfferList = React.memo((props: IProps) => {
    const {ref, isInitialOfferListFetchDone, list, metaDataTitle, selectedRegion, className, isSidebarReserved, offerListSubType} = props;
    const {count, offers, unavailable_offers, unavailable_offers_count, soon_finished_offers, requestState, latestQuery} = list;
    const offersCount = count;
    const isFilteredByFinishedConstruction = latestQuery.construction_end_date === "0";
    const hasNoSelectedOffersToShow = offers.length === 0;
    const hasOffersThatWillBeSoonFinishedToShow = soon_finished_offers.length > 0;
    const showSoonFinishedListing = isFilteredByFinishedConstruction && hasNoSelectedOffersToShow && hasOffersThatWillBeSoonFinishedToShow;
    const addressContext = React.useMemo(
        () =>
            getOfferCardAddressContext({
                searchedRegionQuery: latestQuery.region,
                searchDistance: latestQuery.distance,
                selectedRegions: selectedRegion
            }),
        [latestQuery.distance, latestQuery.region, selectedRegion]
    );

    const renderOfferListVariant = () => {
        const hasRequestSucceed = requestState === RequestState.Success;

        // When there are active or unavailable offers to show (or list is still loading)
        if (offersCount || (!showSoonFinishedListing && unavailable_offers_count > 0)) {
            return (
                <OfferListingUspAnalyticsProvider addressContext={addressContext}>
                    <DefaultOfferListing
                        list={list}
                        metaDataTitle={metaDataTitle}
                        selectedRegion={selectedRegion}
                        offerListSubType={offerListSubType}
                        isSidebarReserved={isSidebarReserved}
                        isInitialOfferListFetchDone={isInitialOfferListFetchDone}
                        addressContext={addressContext}
                    />
                </OfferListingUspAnalyticsProvider>
            );
        }

        // When user requested offers that have been constructed, yet we have nothing to show. Show offers that soon will be finished
        if (showSoonFinishedListing && hasRequestSucceed) {
            return (
                <OfferListingUspAnalyticsProvider addressContext={addressContext}>
                    <SoonFinishedOffersListing
                        offers={soon_finished_offers}
                        unavailableOffers={unavailable_offers}
                        dividerVisible
                        addressContext={addressContext}
                    />
                </OfferListingUspAnalyticsProvider>
            );
        }

        // When there is nothing we can show, render after fetch finished
        if (hasRequestSucceed) {
            return (
                <WideContent>
                    <EmptyListWithNewsLetter className={css({mt: 5})} useHeader />
                </WideContent>
            );
        }
    };

    return (
        <div className={className} ref={ref}>
            {renderOfferListVariant()}
        </div>
    );
}, isEqual);
